export default "__VITE_ASSET__DHZ$FOMH__"